import type { Dispatch, RefObject, SetStateAction } from 'react';
import { CaretDownIcon } from '@phosphor-icons/react';
import LogoMPF from 'volto-ministerio-publico-federal/components/Logo/LogoHorizontalSVG';
import AccessibilityIcon from 'volto-ministerio-publico-federal/components/Icons/Accessibility';
import {
  MPFButton,
  MPFLink,
} from 'volto-ministerio-publico-federal/components/UI';
import { AccessibilityControls } from './AccessibilityControls';
import { MobileOverflowMenu } from './MobileOverflowMenu';
import { INSTITUTIONAL_LINKS } from './constants';
import { comPrefixo } from 'volto-ministerio-publico-federal/helpers/Url/subpath';

interface SuperiorBarProps {
  title: string;
  subtitle: string;
  homeUrl: string;

  a11y: any;
  a11yOpen: boolean;
  setA11yOpen: Dispatch<SetStateAction<boolean>>;
  a11yRef: any;
  accessibilityLink: string;
  sitemap_link: string;
  overflowOpen: boolean;
  onToggleOverflow: () => void;
  overflowRef: RefObject<HTMLDivElement | null>;
  overflowButtonRef: RefObject<HTMLButtonElement | null>;
}
export const SuperiorBar = ({
  title,
  subtitle,
  homeUrl,
  a11y,
  a11yOpen,
  setA11yOpen,
  a11yRef,
  accessibilityLink,
  sitemap_link,
  overflowOpen,
  onToggleOverflow,
  overflowRef,
  overflowButtonRef,
}: SuperiorBarProps) => {
  return (
    <div className="mpf-topbar__upper">
      <div className="mpf-topbar__upper_container">
        <div className="mpf-topbar__upper-grid">
          {}
          <div className="mpf-topbar__brand-wrap">
            <MPFLink
              href={homeUrl}
              className="mpf-topbar__brand"
              aria-label={`${title} - ${subtitle}`}
            >
              <span className="mpf-topbar__brand-logo" aria-hidden="true">
                <LogoMPF className="mpf-topbar__logo" />
              </span>
            </MPFLink>

            <MobileOverflowMenu
              open={overflowOpen}
              onToggle={onToggleOverflow}
              a11y={a11y}
              accessibilityLink={accessibilityLink}
              sitemapLink={sitemap_link}
              containerRef={overflowRef}
              buttonRef={overflowButtonRef}
            />
          </div>

          {}
          <div className="mpf-topbar__upper-actions">
            {}
            <nav
              className="mpf-topbar__inst-links"
              aria-label="Links institucionais"
            >
              <ul className="mpf-topbar__inst-list">
                {INSTITUTIONAL_LINKS.map((link) => (
                  <li key={link.href} className="mpf-topbar__inst-item">
                    <MPFLink
                      href={link.href}
                      className="mpf-topbar__inst-link"
                      openInNewTab={link?.external || undefined}
                    >
                      {link.label}
                    </MPFLink>
                  </li>
                ))}
              </ul>
            </nav>

            {}
            <div className="mpf-topbar__tools">
              <div className="mpf-topbar__a11y">
                {}
                <span aria-hidden="true" className="mpf-topbar__a11y-sep" />
                <a
                  href={comPrefixo(accessibilityLink)}
                  className="mpf-topbar__a11y-link"
                >
                  <AccessibilityIcon
                    className="mpf-topbar__a11y-link-icon"
                    aria-hidden="true"
                  />
                  Acessibilidade
                </a>
                <span aria-hidden="true" className="mpf-topbar__a11y-sep" />
                <AccessibilityControls
                  a11y={a11y}
                  variant="desktop"
                  sitemapLink={sitemap_link}
                />
              </div>

              <div className="mpf-topbar__a11y-compact" ref={a11yRef}>
                <MPFButton
                  variant="unstyled"
                  className="mpf-topbar__a11y-compact-button"
                  aria-haspopup="menu"
                  aria-expanded={a11yOpen}
                  onClick={() => setA11yOpen((open) => !open)}
                >
                  <AccessibilityIcon
                    className="mpf-topbar__a11y-link-icon"
                    aria-hidden="true"
                  />
                  Acessibilidade
                  <CaretDownIcon
                    className={`mpf-topbar__chevron${
                      a11yOpen ? ' mpf-topbar__chevron--open' : ''
                    }`}
                    aria-hidden="true"
                  />
                </MPFButton>
                {a11yOpen && (
                  <div className="mpf-topbar__a11y-compact-menu" role="menu">
                    <a
                      href={comPrefixo(accessibilityLink)}
                      className="mpf-topbar__dropdown-link"
                    >
                      Acessibilidade
                    </a>
                    <div className="mpf-topbar__a11y-compact-controls">
                      <AccessibilityControls a11y={a11y} variant="mobile" />
                    </div>
                    <a
                      href={comPrefixo(sitemap_link)}
                      className="mpf-topbar__dropdown-link"
                    >
                      Mapa do site
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
